<template>
  <v-layout column>
    <v-card
      v-if="title"
      class="mx-auto"
      width="100%"
      aria-labelledby="shop-section-title"
    >
      <v-card-title
        id="shop-section-title"
        class="heading landing-news-title"
      >
        {{ title }}
      </v-card-title>

      <v-card-subtitle v-if="description">
        {{ description }}
      </v-card-subtitle>

      <v-card-actions
        v-if="!isLoading"
      >
        <v-flex
          xs12
          sm12
          md12
          lg12
          my-2
          full-width
          align-middle
          justify-middle
          text-center
          column
        >
          <v-btn
            aria-label="See more from our shop"
            role="link"
            class="accent"
            large
            width="100%"
            @click="goTo(physicalShop)"
          >
            <span class="pr-2">
              {{ $t('components.goodsShop.seeMore') }}
            </span>
            <v-icon>fa-duotone fa-angles-right</v-icon>
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>

    <v-divider
      v-if="title"
    />

    <v-layout
      pl-4
      pr-4
      :class="{
        column: $vuetify.breakpoint.mdAndDown || isLoading,
        row: $vuetify.breakpoint.lgAndUp,
      }"
      style="width: 100%"
      :aria-busy="isLoading"
      role="region"
      aria-label="Product collection"
    >
      <!-- Products -->
      <v-flex
        v-if="!isLoading"
        xs12
        sm12
        md12
        lg12
        class="mx-auto"
        justify="center"
        row
      >
        <v-card
          v-for="product in collection"
          :key="product.id"
          class="my-10"
          max-width="374"
          :width="productWidth"
          ripple
          role="link"
          tabindex="0"
          :aria-label="`Product: ${product.name}, Price: ${product.price}, Category: ${product.category}`"
          @click="goTo(product.link)"
          @keydown.enter="goTo(product.link)"
        >
          <v-img
            v-if="product.image"
            height="250"
            :src="product.image"
            :alt="`${product.name} preview image`"
          />

          <v-card-title>{{ product.name }}</v-card-title>

          <v-card-text>
            <div class="my-4 text-subtitle-1">
              {{ product.price }} • {{ product.category }}
            </div>
            <div>{{ product.description }}</div>
          </v-card-text>

          <v-divider class="mx-4" />

          <v-card-text>
            <v-chip-group
              active-class="accent-4"
              column
              aria-label="Product tags"
            >
              <v-chip
                v-for="tag in product.tags"
                :key="`${tag}-${product.name.replace(/ /g, '-')}`"
                :aria-label="`Tag: ${tag}`"
              >
                {{ tag }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Loading fallback -->
      <v-flex
        v-if="isLoading"
        xs12
        sm12
        md12
        lg6
        pt-8
        pb-8
        full-width
        align-middle
        justify-middle
        text-center
        column
        role="status"
        aria-live="polite"
        aria-label="Loading shop collection"
      >
        <v-btn
          large
          icon
          disabled
          aria-hidden="true"
        >
          <v-icon>fal fa-circle-notch fa-spin</v-icon>
        </v-btn>
        <div class="mt-2">
          {{ $t('components.loading') }}
        </div>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import links from '@/constants/links'

export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        collection: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            physicalShop: links.communities.goodsStore
        }
    },
    computed: {
        productWidth() {
            return this.$vuetify.breakpoint.lgAndUp ? '25%' : '100%'
        }
    },
    methods: {
        goTo(link) {
            // track event
            // this.$ga.event("rapidRegister", "download-game", link);
            // go to link
            window.open(link);
        },
    }
}
</script>
